import { Reducer } from 'redux';
import { IConfigState } from '../types/config';

const initialState = {
  numProjectionYears: 20 // 2018  to 2035
  // numProjectionYears: 20 // 2018 to 2038
}

const configReducer: Reducer<IConfigState> = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    default:
      return state;
  }
}

export default configReducer;

export const getNumProjectionYears = (state: IConfigState) => state.numProjectionYears;



// WEBPACK FOOTER //
// ./src/store/reducers/config.ts